import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { ANALYTIC_EVENTS, Analytics } from 'analytics/Analytics';
import { BaseCard, LogoKassa, LogoKassaStyle } from 'views/components/base/ui';
import { MainLayout } from 'views/layouts';
import { Fade } from 'views/shared/fade';

const NotFound = () => {
  const formKey = 'default';

  useEffect(() => {
    Analytics.sentEvent(ANALYTIC_EVENTS.pagePayNotFound);
  }, []);

  return (
    <MainLayout formKey={formKey}>
      <Fade className="w-full h-full flex flex-grow flex-col md:max-h-[534px]">
        <BaseCard>
          <div className="bg-white md:bg-base-gray-100 flex-grow w-full h-full md:rounded-large col-start-1 col-end-3 flex flex-col justify-center items-center text-center gap-8 p-8">
            <div className="bg-error-404 flex h-full w-full flex-col items-center justify-center bg-[size:100px_auto] bg-center bg-no-repeat xs:bg-[size:248px_auto] md:bg-[size:auto]">
              <div className="flex flex-grow flex-col items-center justify-center gap-9">
                <p className="text-6xl font-bold">Ой</p>
                <div className="flex flex-col items-center justify-center">
                  <h3 className="mb-1 text-center font-bold">Что-то пошло не так</h3>
                  <p className="text-center text-sm">Кажется, у нас нет такой страницы.</p>
                  <p className="text-center text-sm">
                    Проверьте ссылку или вернитесь{' '}
                    <Link to="/" className="text-skin-link">
                      на главную
                    </Link>
                  </p>
                </div>
              </div>

              <div className="flex justify-center self-stretch md:hidden">
                <LogoKassa style={LogoKassaStyle.DARK} />
              </div>
            </div>
          </div>
        </BaseCard>
      </Fade>
    </MainLayout>
  );
};

export default NotFound;
